export var EnumUxTypes;
(function (EnumUxTypes) {
    EnumUxTypes["LINK"] = "link";
    EnumUxTypes["BUTTON"] = "button";
    EnumUxTypes["BUTTON_FLOATING"] = "button_floating";
    EnumUxTypes["BUTTON_BOTTOM_BAR"] = "button_bottombar";
    EnumUxTypes["BUTTON_TOP_BAR"] = "button_topbar";
    EnumUxTypes["BUTTON_TOGGLE"] = "button_toggle";
    EnumUxTypes["ICON"] = "icon";
    EnumUxTypes["ICON_MENU_ITEM"] = "icon_menu_item";
    EnumUxTypes["IMAGE"] = "image";
    EnumUxTypes["LIST_CELL"] = "list_cell";
    EnumUxTypes["LIST"] = "list";
    EnumUxTypes["SWIPE"] = "swipe";
    EnumUxTypes["SCROLL"] = "scroll";
    EnumUxTypes["TAB"] = "tab";
    EnumUxTypes["SLIDER"] = "slider";
    EnumUxTypes["CHECKBOX"] = "checkbox";
    EnumUxTypes["RADIO"] = "radio";
    EnumUxTypes["VIDEO"] = "video";
    EnumUxTypes["SCREEN"] = "screen";
    EnumUxTypes["MODAL"] = "modal";
    EnumUxTypes["RATING_ADD"] = "ratings_add";
    EnumUxTypes["NA"] = "NA";
})(EnumUxTypes || (EnumUxTypes = {}));
export var EnumWidgets;
(function (EnumWidgets) {
    EnumWidgets["AD_UNTIL"] = "ad_unit";
    EnumWidgets["ADD_LISTING"] = "add_listing";
    EnumWidgets["ADD_LISTING_SIMILAR"] = "add_listing_similar";
    EnumWidgets["BOTTOM_STICKY"] = "bottom_sticky";
    EnumWidgets["CATEGORIES_LIST_ICON"] = "categories_list_icons";
    EnumWidgets["CONTACT_US"] = "contact_US";
    EnumWidgets["EXPORT_LISTING_OPTIONS"] = "export_listing_options";
    EnumWidgets["FILTERS"] = "filters";
    EnumWidgets["FILTERS_FACETS"] = "filters_facets";
    EnumWidgets["GENERAL_TIPS"] = "general_tips";
    EnumWidgets["HEADER"] = "header";
    EnumWidgets["HEADER_STICKY"] = "header_sticky";
    EnumWidgets["REELS_LIST"] = "reels_list";
    EnumWidgets["LISTINGS_CONTINUE_BROWSING"] = "listings_continue_browsing";
    EnumWidgets["LISTING_RECENTLY_VIEWED"] = "listings_recently_viewed";
    EnumWidgets["LISTING_LATEST_BY_CATEGORY"] = "listings_latest_by_category";
    EnumWidgets["LISTING_LOCATION_MAP"] = "listing_location_and_map";
    EnumWidgets["LISTING_INFORMATION"] = "listing_information";
    EnumWidgets["LISTING_DESCRIPTION"] = "listing_description";
    EnumWidgets["LISTING_IMAGE"] = "listing_image";
    EnumWidgets["LISTING_TITLE"] = "listing_title";
    EnumWidgets["LISTING_PRICE"] = "listing_price";
    EnumWidgets["LISTING_CELL"] = "listing_cell";
    EnumWidgets["LISTING_LEADS"] = "listing_leads";
    EnumWidgets["LISTER_OVERVIEW"] = "lister_overview";
    EnumWidgets["LISTER_MEMBER_OPENSOOQ_LINK"] = "lister_member_opensooq_link";
    EnumWidgets["LISTING_SIMILAR"] = "listings_similar";
    EnumWidgets["LISTING_RECOMMENDED"] = "listings_recommended";
    EnumWidgets["LISTING_QUALITY_SCORE"] = "listing_quality_score";
    EnumWidgets["LISTING_STATISTICS"] = "listing_statistics";
    EnumWidgets["LISTING_DETAILS"] = "listing_details";
    EnumWidgets["NAVIGATION_BOTTOM_BAR"] = "navigation_bottom_bar";
    EnumWidgets["RESULTS_HEADER"] = "results_header";
    EnumWidgets["RATING_ADD"] = "ratings_add";
    EnumWidgets["RATING_SUMMARY"] = "ratings_summary";
    EnumWidgets["RATING_BADGES"] = "ratings_badges";
    EnumWidgets["RATING_REVIEWS"] = "ratings_reviews";
    EnumWidgets["PROMOTE_LISTING"] = "promote_listing";
    EnumWidgets["SPOTLIGHT_BOTTUN"] = "spotlight_button";
    EnumWidgets["SHARE_LISTING_OPTIONS"] = "share_listing_options";
    EnumWidgets["SEARCH_BAR"] = "search_bar";
    EnumWidgets["SLIDERS"] = "sliders";
    EnumWidgets["TABS"] = "tabs";
    EnumWidgets["WALLET_CELL"] = "wallet_cell";
    EnumWidgets["BOTTOM_BAR"] = "bottom_bar";
    EnumWidgets["NA"] = "NA";
})(EnumWidgets || (EnumWidgets = {}));
export var EnumActionNameLevel1;
(function (EnumActionNameLevel1) {
    EnumActionNameLevel1["CALL"] = "call";
    EnumActionNameLevel1["APPLY"] = "apply";
    EnumActionNameLevel1["ADD"] = "add";
    EnumActionNameLevel1["VIEW"] = "view";
    EnumActionNameLevel1["ORDER"] = "order";
    EnumActionNameLevel1["FAVORITE"] = "favorite";
    EnumActionNameLevel1["MESSAGE"] = "message";
    EnumActionNameLevel1["AUTHENTICATE"] = "authenticate";
    EnumActionNameLevel1["FOLLOW"] = "follow";
    EnumActionNameLevel1["SEARCHES_SAVE"] = "searches_save";
    EnumActionNameLevel1["SHARE"] = "share";
    EnumActionNameLevel1["REPORT"] = "report";
    EnumActionNameLevel1["RATING"] = "rating";
    EnumActionNameLevel1["SEARCH"] = "search";
    EnumActionNameLevel1["SCREEN"] = "screen";
    EnumActionNameLevel1["PERMISSION"] = "permission";
    EnumActionNameLevel1["NA"] = "NA";
})(EnumActionNameLevel1 || (EnumActionNameLevel1 = {}));
export var EnumActionNameLevel2;
(function (EnumActionNameLevel2) {
    EnumActionNameLevel2["LOAN"] = "loan";
    EnumActionNameLevel2["LISTING"] = "listing";
    EnumActionNameLevel2["CV"] = "cv";
    EnumActionNameLevel2["MEMBER"] = "member";
    EnumActionNameLevel2["LISTING_ADD"] = "listing_add";
    EnumActionNameLevel2["LISTING_REMOVE"] = "listing_remove";
    EnumActionNameLevel2["ADD"] = "add";
    EnumActionNameLevel2["REMOVE"] = "remove";
    EnumActionNameLevel2["SEARCH"] = "search";
    EnumActionNameLevel2["APP"] = "app";
    EnumActionNameLevel2["KEYWORD"] = "keyword";
    EnumActionNameLevel2["TAXONOMY"] = "taxonomy";
    EnumActionNameLevel2["FILTERS"] = "filters";
    EnumActionNameLevel2["SIMILAR"] = "similar";
    EnumActionNameLevel2["LOAD"] = "load";
    EnumActionNameLevel2["START"] = "start";
    EnumActionNameLevel2["PRODUCTS"] = "products";
    EnumActionNameLevel2["SELLER"] = "seller";
    EnumActionNameLevel2["BUYER"] = "buyer";
    EnumActionNameLevel2["LOCATION"] = "location";
    EnumActionNameLevel2["NA"] = "NA";
})(EnumActionNameLevel2 || (EnumActionNameLevel2 = {}));
export var EnumActionNameLevel3;
(function (EnumActionNameLevel3) {
    EnumActionNameLevel3["CLICK"] = "click";
    EnumActionNameLevel3["SUCCESS"] = "success";
    EnumActionNameLevel3["VIEW"] = "view";
    EnumActionNameLevel3["SUBMIT"] = "submit";
    EnumActionNameLevel3["SEND"] = "send";
    EnumActionNameLevel3["ALLOW"] = "allow";
    EnumActionNameLevel3["DENY"] = "deny";
    EnumActionNameLevel3["NA"] = "NA";
})(EnumActionNameLevel3 || (EnumActionNameLevel3 = {}));
export const LoggingScreenNames = {
    "": "home",
    "/": "home",
    "chats": "chat_center",
    "notifications": "notifications_timeline",
    "listing-view": "my_listing_view",
    "my-listings": "my_listings",
    "draft-listings": "NA",
    "favorite-listings": "favorites_listings",
    "lsting_view": "listing_view",
    "recently-viewed": "NA",
    "following-listings": "follow_listings",
    "job-applications": "NA",
    "saved-search": "NA",
    "recent-search": "NA",
    "my-account": "my_account",
    "my-rating": "my_ratings",
    "my-wallet": "my_wallet",
    "followers": "my_follows",
    "following": "my_follows",
    "settings": "settings",
    "products": "products",
    "invite-friends": "invite_friends",
};
export var EnumCellType;
(function (EnumCellType) {
    EnumCellType["TEXT_ONLY"] = "textOnly";
    EnumCellType["CLASSIC"] = "classic";
    EnumCellType["IMAGE"] = "image";
})(EnumCellType || (EnumCellType = {}));
export var EnumGeneratedBy;
(function (EnumGeneratedBy) {
    EnumGeneratedBy["USER"] = "user";
    EnumGeneratedBy["SYSTEM"] = "system";
    EnumGeneratedBy["TIME"] = "time";
    EnumGeneratedBy["USER_SHORTCUT"] = "user_shortcut";
})(EnumGeneratedBy || (EnumGeneratedBy = {}));
export var EnumReferenceEntity;
(function (EnumReferenceEntity) {
    EnumReferenceEntity["MEMBER"] = "member";
    EnumReferenceEntity["POST"] = "post";
    EnumReferenceEntity["ORDER"] = "order";
    EnumReferenceEntity["SAVED_SEARCH"] = "saved_searches";
})(EnumReferenceEntity || (EnumReferenceEntity = {}));
export const HTML_ELEMENTS_CLASSES = [
    "searchFacetsSource",
    "viewMoreBtnSource",
    "homeFacetsSource",
    "megaMenuSource",
    "moreCategorySource",
    "postListItemSource"
];
export const DEFAULT_VALUE = 'NA';
export const DEFAULT_VALUE_COUNTRY = 'xx';
export const EMPTY_LOCATION = {
    latitude: DEFAULT_VALUE,
    longitude: DEFAULT_VALUE
};
export const EMPTY_ACTION_NAME = {
    L1: EnumActionNameLevel1.NA,
    L2: EnumActionNameLevel2.NA,
    L3: EnumActionNameLevel3.NA
};
